import { create } from 'zustand';

/**
 * Ruhig schreiben (PF 57): welche Markierungen der Text zeigt – alle, nur Widersprüche oder keine. Es ist nur die Darstellung; Vorschläge
 * und Prüfungen laufen weiter, die Zähler bleiben. Der Browser merkt sich die Wahl (gilt für alle Texte).
 */
export type MarkView = 'all' | 'conflicts' | 'none';
export const MARK_VIEWS: MarkView[] = ['all', 'conflicts', 'none'];

const STORE_KEY = 'dispositio.markView';

function load(): MarkView {
  try {
    const v = localStorage.getItem(STORE_KEY);
    return v === 'conflicts' || v === 'none' ? v : 'all';
  } catch {
    return 'all';
  }
}

interface MarkViewState {
  view: MarkView;
  setView: (view: MarkView) => void;
}

export const useMarkView = create<MarkViewState>((set) => ({
  view: load(),
  setView: (view) => {
    set({ view });
    try {
      localStorage.setItem(STORE_KEY, view);
    } catch {
      // privates Fenster o. Ä.: dann eben nicht gemerkt
    }
  },
}));

/**
 * Klassen am Editor, je Farbe der Bildsprache, die zurücktritt: Blau (Bestätigtes), Gelb (Vorschläge), Rot (Widersprüche). Beim Prüfen
 * bleiben die Vorschläge sichtbar – darum hat man es eingeschaltet.
 */
export function quietClasses(view: MarkView, review: boolean): string {
  const quiet: string[] = [];
  if (view !== 'all') quiet.push('quiet-confirmed');
  if (view !== 'all' && !review) quiet.push('quiet-suggest');
  if (view === 'none') quiet.push('quiet-conflict');
  return quiet.join(' ');
}
